"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDiveSplatterType = exports.EDiveBulletTracking = exports.EDiveBulletSubtype = exports.EMessageBulletTeamType = void 0;
var EMessageBulletTeamType;
(function (EMessageBulletTeamType) {
    EMessageBulletTeamType[EMessageBulletTeamType["Crew"] = 0] = "Crew";
    EMessageBulletTeamType[EMessageBulletTeamType["Alien"] = 1] = "Alien";
})(EMessageBulletTeamType = exports.EMessageBulletTeamType || (exports.EMessageBulletTeamType = {}));
var EDiveBulletSubtype;
(function (EDiveBulletSubtype) {
    EDiveBulletSubtype[EDiveBulletSubtype["MeleeSlash"] = 0] = "MeleeSlash";
    EDiveBulletSubtype[EDiveBulletSubtype["Fireball"] = 1] = "Fireball";
    EDiveBulletSubtype[EDiveBulletSubtype["Arrow"] = 2] = "Arrow";
    EDiveBulletSubtype[EDiveBulletSubtype["Bullet"] = 3] = "Bullet";
})(EDiveBulletSubtype = exports.EDiveBulletSubtype || (exports.EDiveBulletSubtype = {}));
var EDiveBulletTracking;
(function (EDiveBulletTracking) {
    EDiveBulletTracking[EDiveBulletTracking["Tile"] = 0] = "Tile";
    EDiveBulletTracking[EDiveBulletTracking["Crew"] = 1] = "Crew";
})(EDiveBulletTracking = exports.EDiveBulletTracking || (exports.EDiveBulletTracking = {}));
var EDiveSplatterType;
(function (EDiveSplatterType) {
    EDiveSplatterType[EDiveSplatterType["None"] = 0] = "None";
    EDiveSplatterType[EDiveSplatterType["Any"] = 1] = "Any";
    EDiveSplatterType[EDiveSplatterType["Blood"] = 2] = "Blood";
    EDiveSplatterType[EDiveSplatterType["Bone"] = 3] = "Bone";
})(EDiveSplatterType = exports.EDiveSplatterType || (exports.EDiveSplatterType = {}));
